export default {
  id: '86a53f7fcc',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=SAH><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>Subarachnoid Hemorrhage</div><div class=right></div><div class=subnavbar><div class=subnavbar-inner><div class="segmented segmented-strong"><a class="button tab-link tab-link-active" href=#tab1>Hunt and Hess</a> <a class="button tab-link" href=#tab2>Fisher</a> <span class=segmented-highlight></span></div></div></div></div></div><div class=page-content><div class=tabs><div class="tab tab-active" id=tab1><div class="block block-strong no-hairlines-md margin-top-half"><p><b>Hunt and Hess grading system:</b></p><dl><dt>Grade 0</dt><dd>Unruptured aneurysm</dd><dt>Grade I</dt><dd>Asymptomatic or mild headache and slight nuchal rigidity</dd><dt>Grade Ia</dt><dd>Fixed neurologic deficit without acute meningeal/brain reaction</dd><dt>Grade II</dt><dd>Cranial nerve palsy, moderate to severe headache, nuchal rigidity</dd><dt>Grade III</dt><dd>Mild focal deficit, lethargy, or confusion</dd><dt>Grade IV</dt><dd>Stupor, moderate to severe hemiparesis, early decerebrate rigidity</dd><dt>Grade V</dt><dd>Deep coma, decerebrate rigidity, moribund appearance</dd></dl></div></div><div class=tab id=tab2><div class="block block-strong no-hairlines-md margin-top-half"><p><b>The Fisher scale (CT scan appearance):</b></p><dl><dt>Group 1</dt><dd>No blood detected</dd><dt>Group 2</dt><dd>Diffuse deposition of subarachnoid blood, no clots, and no layers of blood greater than 1 mm</dd><dt>Group 3</dt><dd>Localized clots and/or vertical layers of blood 1 mm or greater in thickness</dd><dt>Group 4</dt><dd>Diffuse or no subarachnoid blood, but intracerebral or intraventricular clots are present</dd></dl></div></div></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};